import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Week } from '../../../../../common/enums/Week';
import { Availability } from '../../../../../common/enums/Availability';

export interface GeneralInfoAvailabilityDayState {
  day?: string;
  startTime: string;
  endTime: string;
  availability: string;
}

export interface GeneralInfoAvailabilityFormState {
  monday: GeneralInfoAvailabilityDayState;
  tuesday: GeneralInfoAvailabilityDayState;
  wednesday: GeneralInfoAvailabilityDayState;
  thursday: GeneralInfoAvailabilityDayState;
  friday: GeneralInfoAvailabilityDayState;
  saturday: GeneralInfoAvailabilityDayState;
  sunday: GeneralInfoAvailabilityDayState;
}

const initialDayState: GeneralInfoAvailabilityDayState = {
  startTime: '',
  endTime: '',
  availability: Availability.Open,
};

export const createGeneralInfoAvailabilityInitialState = (): GeneralInfoAvailabilityFormState => ({
  monday: { ...initialDayState },
  tuesday: { ...initialDayState },
  wednesday: { ...initialDayState },
  thursday: { ...initialDayState },
  friday: { ...initialDayState },
  saturday: { ...initialDayState },
  sunday: { ...initialDayState },
});

const initialState: GeneralInfoAvailabilityFormState = createGeneralInfoAvailabilityInitialState();

export const generalInfoIntroSlice = createSlice({
  name: 'generalInfoAvailability',
  initialState,
  reducers: {
    setGeneralInfoAvailabilityStateDefault: () => {
      return { ...initialState };
    },
    submitGeneralInfoAvailability: (state, action: PayloadAction<GeneralInfoAvailabilityDayState>) => {
      const day = action.payload.day as string;
      switch (day) {
        case Week.Monday: {
          state.monday = action.payload;
          break;
        }
        case Week.Tuesday: {
          state.tuesday = action.payload;
          break;
        }
        case Week.Wednesday: {
          state.wednesday = action.payload;
          break;
        }
        case Week.Thursday: {
          state.thursday = action.payload;
          break;
        }
        case Week.Friday: {
          state.friday = action.payload;
          break;
        }
        case Week.Saturday: {
          state.saturday = action.payload;
          break;
        }
        case Week.Sunday: {
          state.sunday = action.payload;
          break;
        }
      }
    },
    submitGeneralInfoAvailabilityAll: (state, action: PayloadAction<GeneralInfoAvailabilityFormState>) => {
      return action.payload;
    },
  },
});

export const { setGeneralInfoAvailabilityStateDefault, submitGeneralInfoAvailability, submitGeneralInfoAvailabilityAll } =
  generalInfoIntroSlice.actions;

export default generalInfoIntroSlice.reducer;
